export default "__VITE_ASSET__CBHmOLyz__"